// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as $$Array from "../../../../../../../node_modules/rescript/lib/es6/array.js";
import * as Weekday from "../../types/common/Weekday.bs.js";
import * as Json_encode from "../../../../../../../node_modules/@glennsl/bs-json/src/Json_encode.bs.js";
import * as DateTime$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DateTime.bs.js";

function encodeSurgeStrategy(surgeStrategy) {
  if (surgeStrategy.TAG === /* Flat */0) {
    return Json_encode.object_({
                hd: [
                  "type",
                  "FLAT"
                ],
                tl: {
                  hd: [
                    "amount",
                    surgeStrategy._0
                  ],
                  tl: /* [] */0
                }
              });
  } else {
    return Json_encode.object_({
                hd: [
                  "type",
                  "MULTIPLIER"
                ],
                tl: {
                  hd: [
                    "multiplier",
                    surgeStrategy._0
                  ],
                  tl: /* [] */0
                }
              });
  }
}

function encodeCampaign(campaign) {
  if (List.length(campaign.zones) === 0) {
    var startDate = campaign.startDate;
    var endDate = campaign.endDate;
    return Json_encode.object_({
                hd: [
                  "campaign_name",
                  campaign.campaignName
                ],
                tl: {
                  hd: [
                    "geo_region_id",
                    campaign.geoRegionId
                  ],
                  tl: {
                    hd: [
                      "vehicle_type_ids",
                      $$Array.map((function (id) {
                              return id;
                            }), $$Array.of_list(campaign.vehicleTypesIds))
                    ],
                    tl: {
                      hd: [
                        "surge_strategy",
                        encodeSurgeStrategy(campaign.surgeStrategy)
                      ],
                      tl: {
                        hd: [
                          "campaign_start_date",
                          DateTime$Catalyst.toString("YYYY-MM-DD", startDate)
                        ],
                        tl: {
                          hd: [
                            "campaign_end_date",
                            DateTime$Catalyst.toString("YYYY-MM-DD", endDate)
                          ],
                          tl: {
                            hd: [
                              "weekdays",
                              $$Array.map(Weekday.toString, $$Array.of_list(campaign.weekdays))
                            ],
                            tl: {
                              hd: [
                                "window_start_mins",
                                campaign.startWindow
                              ],
                              tl: {
                                hd: [
                                  "window_end_mins",
                                  campaign.endWindow
                                ],
                                tl: {
                                  hd: [
                                    "priority",
                                    campaign.priority
                                  ],
                                  tl: /* [] */0
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              });
  }
  var startDate$1 = campaign.startDate;
  var endDate$1 = campaign.endDate;
  return Json_encode.object_({
              hd: [
                "campaign_name",
                campaign.campaignName
              ],
              tl: {
                hd: [
                  "geo_region_id",
                  campaign.geoRegionId
                ],
                tl: {
                  hd: [
                    "vehicle_type_ids",
                    $$Array.map((function (id) {
                            return id;
                          }), $$Array.of_list(campaign.vehicleTypesIds))
                  ],
                  tl: {
                    hd: [
                      "surge_strategy",
                      encodeSurgeStrategy(campaign.surgeStrategy)
                    ],
                    tl: {
                      hd: [
                        "campaign_start_date",
                        DateTime$Catalyst.toString("YYYY-MM-DD", startDate$1)
                      ],
                      tl: {
                        hd: [
                          "campaign_end_date",
                          DateTime$Catalyst.toString("YYYY-MM-DD", endDate$1)
                        ],
                        tl: {
                          hd: [
                            "weekdays",
                            $$Array.map(Weekday.toString, $$Array.of_list(campaign.weekdays))
                          ],
                          tl: {
                            hd: [
                              "window_start_mins",
                              campaign.startWindow
                            ],
                            tl: {
                              hd: [
                                "window_end_mins",
                                campaign.endWindow
                              ],
                              tl: {
                                hd: [
                                  "priority",
                                  campaign.priority
                                ],
                                tl: {
                                  hd: [
                                    "zone_ids",
                                    $$Array.map((function (zone) {
                                            return zone;
                                          }), $$Array.of_list(campaign.zones))
                                  ],
                                  tl: /* [] */0
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            });
}

function encodeCreateCampaignPayload(campaign) {
  return Json_encode.object_({
              hd: [
                "campaign_request",
                encodeCampaign(campaign)
              ],
              tl: /* [] */0
            });
}

var CreateCampaign = {
  encodeSurgeStrategy: encodeSurgeStrategy,
  encodeCampaign: encodeCampaign,
  encodeCreateCampaignPayload: encodeCreateCampaignPayload
};

export {
  CreateCampaign ,
  
}
/* DateTime-Catalyst Not a pure module */
